var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { TextField } from "@folio/stripes/components";
import { useIntl } from "react-intl";
export var DaysOfMonthEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, count = _a.count, disabled = _a.disabled;
    var formatMessage = useIntl().formatMessage;
    var days = useMemo(function () {
        var arr = __spreadArray([], value.days, true);
        while (arr.length < count)
            arr.push(1);
        return arr.slice(0, count);
    }, [value.days, count]);
    var updateDay = function (idx, raw) {
        var num = Math.max(1, Math.min(31, parseInt(raw, 10) || 1));
        var next = __spreadArray([], days, true);
        next[idx] = num;
        onChange({ days: next });
    };
    return (React.createElement("div", null,
        days.map(function (d, idx) { return (React.createElement(TextField, { key: idx, type: "number", min: 1, max: 31, value: d, onChange: function (e) {
                return updateDay(idx, e.target.value);
            }, label: formatMessage({ id: "ui-br-legaldeposits.schedule.daysOfMonth.day" }, { index: idx + 1 }), disabled: disabled })); }),
        React.createElement("p", null, formatMessage({
            id: "ui-br-legaldeposits.schedule.daysOfMonth.fallbackHint",
        }))));
};
